import { initWidget } from '../../utils/Shell';
import GSLoginWidget from './GSLoginWidget.vue';

initWidget('GSLoginWidget', GSLoginWidget);
